<template>
  <b-card>
    <div>
      <div class="mt-3">
        <div class="row">
          <b-form-group label="Location Type" label-for="location-type" class="col-lg-12">
            <b-select v-model="accommodation._type" id="location-type" name="location-type"
              v-validate="{ required: true }" :state="validateState('accommodation._type')">
              <option :value="null" selected>Select a Type</option>
              <option value="BedAndBreakfast">Bed &amp; Breakfast</option>
              <option value="Campground">Campground</option>
              <option value="HotelOrMotel">Hotel or Motel</option>
              <option value="SportsmanLodgeOrCabin">Sportsman Lodge or Cabin</option>
              <option value="VacationRental">Vacation Rental</option>
            </b-select>
            <div class="red"><font-awesome-icon v-if="veeErrors.first('location-type')" icon="exclamation-circle"
                size="1x" style="color:red;" class=" mr-1 fas fa-exclamation-circle" />{{ veeErrors.first('location-type')
                }}</div>
          </b-form-group>
        </div>

        <div class="row">
          <b-form-group label="Reservations Website" label-for="reservationsUrl" class="col-lg-4">
            <b-form-input type="text" id="reservationsUrl" name="reservationsUrl" v-model="accommodation.reservationsUrl"
              @change="onChange" />
            <b-form-invalid-feedback class="d-block red"
              v-if="this.accommodation.reservationsUrl && !urlTest.test(this.accommodation.reservationsUrl)">Must include
              http:// or https://</b-form-invalid-feedback>
          </b-form-group>

          <TelephoneInput label="Reservations Phone Number" id="phone" v-model="accommodation.phone" @input="onChange"
            v-validate="{ required: true }" class="col-lg-3" />
          <!-- <b-form-group label="Reservations Phone Number" label-for="phone" class="col-lg-3">
                <b-form-input type="tel" id="phone" name="phone" v-mask="'(###) ###-####'" @input="dirty=true" v-model="accommodation.phone" @change="onChange" v-validate="{ required: true }" :state="validateState('accommodation.phone')" />
                <div class="red"><font-awesome-icon v-if="veeErrors.first('phone')" icon="exclamation-circle" size="1x" style="color:red;" class=" mr-1 fas fa-exclamation-circle" />{{ veeErrors.first('phone') }}</div>
              </b-form-group> -->

          <b-form-group label="# of Rooms/Spaces/Units" label-for="capacity" class="col-lg-3">
            <b-form-input id="capacity" name="capacity" v-model="accommodation.capacity" @change="onChange"
              v-validate="{ required: true }" :state="validateState('accommodation.capacity')" />
            <div class="red"><font-awesome-icon v-if="veeErrors.first('capacity')" icon="exclamation-circle" size="1x"
                style="color:red;" class=" mr-1 fas fa-exclamation-circle" />{{ veeErrors.first('capacity') }}</div>
          </b-form-group>

          <b-form-group label="Rates" label-for="rates" class="col-lg-2">
            <b-form-input id="rates" name="rates" v-model="accommodation.rates" @change="onChange"
              v-validate="{ required: true }" :state="validateState('accommodation.rates')" />
            <div class="red"><font-awesome-icon v-if="veeErrors.first('rates')" icon="exclamation-circle" size="1x"
                style="color:red;" class=" mr-1 fas fa-exclamation-circle" />{{ veeErrors.first('rates') }}</div>
          </b-form-group>
        </div>
      </div>
      <div class="row text-center">
        <b-form-group label="Meeting Facilities" label-for="meetingFacilities" class="col-lg-3">
          <b-form-checkbox switch id="meetingFacilities" name="meetingFacilities"
            v-model="accommodation.meetingFacilities" @change="onChange" />
          <div v-if="accommodation.meetingFacilities">Meeting Capacity</div>
          <b-form-input v-if="accommodation.meetingFacilities" id="meetingCapacity" name="meetingCapacity"
            v-model="accommodation.meetingCapacity" @change="onChange" />
        </b-form-group>

        <b-form-group label="Pets Allowed" label-for="petsAllowed" class="col-lg-2">
          <b-form-checkbox switch id="petsAllowed" name="petsAllowed" v-model="accommodation.petsAllowed"
            @change="onChange" />
        </b-form-group>

        <b-form-group label="Children Allowed" label-for="childrenAllowed" class="col-lg-2">
          <b-form-checkbox switch id="childrenAllowed" name="childrenAllowed" v-model="accommodation.childrenAllowed"
            @change="onChange" />
        </b-form-group>

        <b-form-group label="Hours Of Operation" label-for="hoursOfOperation" class="col-lg-5">
          <b-form-input id="hours" name="hours" v-model="accommodation.hoursOfOperation" @change="onChange" />
        </b-form-group>
      </div>

      <div class="row mb-3" v-if="accommodation.discounts">
        <div class="col-lg-12">
          <b-form-group label="Discounts" class="">
            <b-card>
              <b-form-checkbox-group id="discounts" name="Discounts" v-model="accommodation.discounts" @change="onChange"
                style="column-count: 2;" stacked>
                <b-form-checkbox value="AAA">AAA</b-form-checkbox>
                <b-form-checkbox value="Government">Government</b-form-checkbox>
                <b-form-checkbox value="Military">Military</b-form-checkbox>
                <b-form-checkbox value="Senior">Senior</b-form-checkbox>
              </b-form-checkbox-group>
            </b-card>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <b-form-group label="General Amenities" label-for="amenities" class="col-lg-12">
          <b-card>
            <b-form-checkbox-group id="amenities" name="amenities" v-model="accommodation.amenities" @change="onChange"
              style="column-count: 2;" stacked>
              <b-form-checkbox value="Cable/Satellite">Cable/Satellite</b-form-checkbox>
              <b-form-checkbox value="Complimentary Breakfast">Complimentary Breakfast</b-form-checkbox>
              <b-form-checkbox value="Fireplace">Fireplace</b-form-checkbox>
              <b-form-checkbox value="Kitchen">Kitchen</b-form-checkbox>
              <b-form-checkbox value="Kitchenette">Kitchenette</b-form-checkbox>
              <b-form-checkbox value="Microwave">Microwave</b-form-checkbox>
              <b-form-checkbox value="Onsite Laundry Facilities">Onsite Laundry Facilities</b-form-checkbox>
              <b-form-checkbox value="Private Bath">Private Bath</b-form-checkbox>
              <b-form-checkbox value="Private Balcony or Patio">Private Balcony or Patio</b-form-checkbox>
              <b-form-checkbox value="Refrigerator">Refrigerator</b-form-checkbox>
              <b-form-checkbox value="Restaurant">Restaurant</b-form-checkbox>
              <b-form-checkbox value="Snack Bar">Snack Bar</b-form-checkbox>
              <b-form-checkbox value="WiFi">WiFi</b-form-checkbox>
              <b-form-checkbox value="Fitness Room">Fitness Room</b-form-checkbox>
              <b-form-checkbox value="Golf Course">Golf Course</b-form-checkbox>
              <b-form-checkbox value="Hiking">Hiking or Walking Trail</b-form-checkbox>
              <b-form-checkbox value="Playground">Playground</b-form-checkbox>
              <b-form-checkbox value="Sauna/Jacuzzi">Sauna/Jacuzzi</b-form-checkbox>
              <b-form-checkbox value="Spa">Spa</b-form-checkbox>
              <b-form-checkbox value="Pool">Swimming Pool</b-form-checkbox>
              <b-form-checkbox value="Television">Television</b-form-checkbox>
              <b-form-checkbox value="Tennis">Tennis Court</b-form-checkbox>
            </b-form-checkbox-group>
          </b-card>
        </b-form-group>
      </div>

      <div class="row">
        <b-form-group label="Water Amenities" label-for="waterAmenities" class="col-lg-12">
          <b-card>
            <b-form-checkbox-group id="waterAmenities" name="waterAmenities" v-model="accommodation.waterAmenities"
              @change="onChange" style="column-count: 2;" stacked>
              <b-form-checkbox value="Boating">Boating</b-form-checkbox>
              <b-form-checkbox value="Boat Ramp">Boat Ramp</b-form-checkbox>
              <b-form-checkbox value="Dock">Dock</b-form-checkbox>
              <b-form-checkbox value="Fishing">Fishing</b-form-checkbox>
            </b-form-checkbox-group>
          </b-card>
        </b-form-group>
      </div>

      <div class="row">
        <b-form-group label="Recreational Amenities" label-for="recreationAmenities" class="col-lg-12">
          <b-card>
            <b-form-checkbox-group id="recreationAmenities" name="recreationAmenities"
              v-model="accommodation.recreationAmenities" style="column-count: 2;" stacked>
              <b-form-checkbox value="Fitness Room">Fitness Room</b-form-checkbox>
              <b-form-checkbox value="Golf Course">Golf Course</b-form-checkbox>
              <b-form-checkbox value="Hiking or Walking Trail">Hiking or Walking Trail</b-form-checkbox>
              <b-form-checkbox value="Playground">Playground</b-form-checkbox>
              <b-form-checkbox value="Sauna/Jacuzzi">Sauna/Jacuzzi</b-form-checkbox>
              <b-form-checkbox value="Spa">Spa</b-form-checkbox>
              <b-form-checkbox value="Swimming Pool">Swimming Pool</b-form-checkbox>
              <b-form-checkbox value="Tennis Court">Tennis Court</b-form-checkbox>
            </b-form-checkbox-group>
          </b-card>
        </b-form-group>
      </div>

      <b-form-group label="Credit Cards Accepted" label-for="creditCards">
        <credit-cards :value="accommodation.creditCards" v-model="accommodation.creditCards" @change="onChange" />
      </b-form-group>

    </div>
  </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import creditCards from '../../../components/CreditCards.vue';
import TelephoneInput from '../../../components/TelephoneInput.vue';

export default {
  components: {
    creditCards,
    TelephoneInput,
  },
  data() {
    return {
      accommodation: {
        reservationsUrl: '',
        phone: '',
        capacity: '',
        rates: '',
        meetingFacilities: false,
        meetingCapacity: '',
        petsAllowed: false,
        childrenAllowed: false,
        amenities: [],
        waterAmenities: [],
        creditCards: [],
        discounts: '',
      },
      submitted: false,
      urlTest: /(http(s?)):\/\//i,
    };
  },
  props: ['value'],
  validations: {
    accommodation: {
      phone: {
        required,
      },
      capacity: {
        required,
      },
      rates: {
        required,
      },
    },
  },
  mounted() {
    let isEmpty = true;
    for (let i = 0; i < Object.keys(this.value).length; i++) {
      if (Object.prototype.hasOwnProperty.call(this.value, Object.keys(this.value)[i])) {
        isEmpty = false;
        break;
      }
    }
    if (!isEmpty) {
      this.accommodation = this.value;
    }
  },
  methods: {
    onChange() {
      this.$emit('input', this.accommodation);
      this.$emit('change', this.accommodation);
    },
    validate() {
      this.submitted = true;
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
  },
};
</script>

<style></style>
